import { isVueAppInDOM, renderApp } from '@/src/shared/component-utilities';

import OrderList from './OrderList.vue';

export function load() {
  const selector = 'zel-order-list';

  if (!isVueAppInDOM(selector)) {
    return;
  }

  renderApp(OrderList, selector);
}
